import { FC, SVGProps } from 'react';

export const NoteIcon: FC<SVGProps<SVGSVGElement>> = ({ className, ...props }) => {
  return (
    <svg
      className={className}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="48" height="48" fill="white" />
      <path
        d="M6 20C6 12.4575 6 8.6863 8.34314 6.34314C10.6863 4 14.4575 4 22 4H26C33.5424 4 37.3138 4 39.6568 6.34314C42 8.6863 42 12.4575 42 20V28C42 35.5424 42 39.3138 39.6568 41.6568C37.3138 44 33.5424 44 26 44H22C14.4575 44 10.6863 44 8.34314 41.6568C6 39.3138 6 35.5424 6 28V20Z"
        fill="#00B38D"
      />
      <path
        d="M33.0378 33.0026C33.3878 32.7296 33.7052 32.4122 34.3402 31.7772L42.255 23.8624C42.4462 23.6712 42.3586 23.3416 42.103 23.2528C41.1688 22.9288 39.9534 22.3202 38.8166 21.1834C37.6798 20.0466 37.0712 18.8312 36.7472 17.897C36.6584 17.6413 36.3288 17.5537 36.1376 17.7451L28.2228 25.6598C27.5878 26.2948 27.2704 26.6122 26.9974 26.9622C26.6754 27.3752 26.3992 27.8218 26.174 28.2946C25.983 28.6952 25.841 29.1212 25.5572 29.973L25.1902 31.0736L24.6068 32.8236L24.0598 34.4646C23.9202 34.8838 24.0292 35.3458 24.3416 35.6584C24.6542 35.9708 25.1162 36.0798 25.5354 35.9402L27.1764 35.3932L28.9264 34.8098L30.027 34.4428C30.8786 34.159 31.3048 34.017 31.7054 33.826C32.1782 33.6008 32.6248 33.3246 33.0378 33.0026Z"
        fill="#242428"
      />
      <path
        d="M44.733 21.3844C46.4224 19.6951 46.4224 16.9562 44.733 15.267C43.0438 13.5777 40.305 13.5777 38.6156 15.267L38.3612 15.5214C38.1156 15.767 38.0044 16.1099 38.0658 16.4517C38.1044 16.6667 38.1758 16.9811 38.306 17.3561C38.5662 18.1063 39.0576 19.091 39.9834 20.0166C40.909 20.9424 41.8938 21.4338 42.6438 21.694C43.019 21.8242 43.3332 21.8956 43.5482 21.9342C43.89 21.9956 44.233 21.8844 44.4786 21.6388L44.733 21.3844Z"
        fill="#242428"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5 18C14.5 17.1716 15.1716 16.5 16 16.5H29C29.8284 16.5 30.5 17.1716 30.5 18C30.5 18.8284 29.8284 19.5 29 19.5H16C15.1716 19.5 14.5 18.8284 14.5 18ZM14.5 26C14.5 25.1716 15.1716 24.5 16 24.5H22C22.8284 24.5 23.5 25.1716 23.5 26C23.5 26.8284 22.8284 27.5 22 27.5H16C15.1716 27.5 14.5 26.8284 14.5 26ZM14.5 34C14.5 33.1716 15.1716 32.5 16 32.5H19C19.8284 32.5 20.5 33.1716 20.5 34C20.5 34.8284 19.8284 35.5 19 35.5H16C15.1716 35.5 14.5 34.8284 14.5 34Z"
        fill="#242428"
      />
    </svg>
  );
};
